export const addItem = (array, addedItem) => [addedItem, ...array];
